import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";

import { i18n } from "@/i18n";

const { t } = i18n.global;

const MIN_PASSWORD_LENGTH = 6;

const SignUp = z.object({
  email: z.string({ required_error: t("validation.required") }).email(t("validation.email")),
  password: z
    .string({ required_error: t("validation.required") })
    .min(MIN_PASSWORD_LENGTH, t("validation.min", { min: MIN_PASSWORD_LENGTH })),
  terms: z.literal(true)
});

export type SignUp = z.infer<typeof SignUp>;

export const signUpValidator = toTypedSchema(SignUp);
